import React, { useState } from 'react';
import { DocumentItem as IDocumentItem } from '../../types/cabinet.types';
import { useI18n } from '../../hooks/useI18n';

interface DocumentItemProps {
  document: IDocumentItem;
  onDelete?: (doc: IDocumentItem) => void;
  onClick?: () => void;
  isDeleting?: boolean;
  className?: string;
}

// ... unchanged logic ...

function formatDate(dateStr: string): string {
  if (!dateStr) return '';
  
  // Формат DD-MM-YYYY або DD.MM.YYYY (з опціональним часом)
  let m = /^(\d{2})[-.](\d{2})[-.](\d{4})(?:[\sT]+(\d{1,2}:\d{2})(?::\d{2})?(?:\.\d+)?Z?)?/.exec(dateStr);
  if (m) {
    return `${m[1]}.${m[2]}.${m[3]}${m[4] ? ' ' + m[4] : ''}`;
  }
  
  // Формат YYYY-MM-DD або YYYY.MM.DD (з опціональним часом)
  m = /^(\d{4})[-.](\d{2})[-.](\d{2})(?:[\sT]+(\d{1,2}:\d{2})(?::\d{2})?(?:\.\d+)?Z?)?/.exec(dateStr);
  if (m) {
    return `${m[3]}.${m[2]}.${m[1]}${m[4] ? ' ' + m[4] : ''}`;
  }
  
  // Fallback
  return dateStr.replace(/-/g, '.');
}

function getMimeIcon(mimeType?: string, url?: string, isPrescription?: boolean, title?: string): React.ReactElement {
  if (title && title.toLowerCase().includes('synevo')) {
    return (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g fill="#004C8C">
          <path id="synevo-petal" d="M12 10.5 C 9.5 7.5, 7.5 3.5, 12 2 C 16.5 3.5, 14.5 7.5, 12 10.5 Z" />
          <use href="#synevo-petal" transform="rotate(60 12 12)" />
          <use href="#synevo-petal" transform="rotate(120 12 12)" />
          <use href="#synevo-petal" transform="rotate(180 12 12)" />
          <use href="#synevo-petal" transform="rotate(240 12 12)" />
          <use href="#synevo-petal" transform="rotate(300 12 12)" />
        </g>
      </svg>
    );
  }
  if (isPrescription) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 20C9.24404 20.0053 7.55023 19.3505 6.2545 18.1654C4.95876 16.9803 4.15575 15.3515 4.00471 13.6021C3.85368 11.8527 4.36567 10.1104 5.43913 8.72074C6.51259 7.33112 8.06911 6.3957 9.79998 6.1C15.5 5 17 4.48 19 2C20 4 21 6.18 21 10C21 15.5 16.22 20 11 20Z" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 21C2 18 3.85 15.64 7.08 15C9.5 14.52 12 13 13 12" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }
  const isPdf = mimeType?.includes('pdf') || url?.endsWith('.pdf');
  const isImage = mimeType?.includes('image');
  if (isPdf) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7.5L14.5 2Z" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 2V8H20" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 13H8" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 17H8" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 9H8" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    );
  }
  if (isImage) {
    return (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <circle cx="8.5" cy="8.5" r="1.5"/>
        <polyline points="21 15 16 10 5 21"/>
      </svg>
    );
  }
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V7.5L14.5 2Z" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14 2V8H20" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 13H8" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 17H8" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 9H8" stroke="#361777" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
  );
}

export const DocumentItem: React.FC<DocumentItemProps> = ({
  document,
  onDelete,
  onClick,
  isDeleting = false,
  className = ''
}) => {
  const { t } = useI18n();
  const [isDownloading, setIsDownloading] = useState(false);
  const isMedyc = document.source === 'medyc';
  const isPrescription = !!document.drugs;

  const handleDownloadPWA = async (url: string, filename: string) => {
    try {
      setIsDownloading(true);
      const finalFilename = filename.toLowerCase().endsWith('.pdf') ? filename : `${filename}.pdf`;

      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const blob = await response.blob();
      const pdfBlob = new Blob([blob], { type: 'application/pdf' });

      // 1) Web Share API — єдиний надійний спосіб на iOS PWA ("Зберегти у файли")
      if (typeof navigator.share === 'function' && navigator.canShare) {
        const file = new File([pdfBlob], finalFilename, { type: 'application/pdf' });
        if (navigator.canShare({ files: [file] })) {
          await navigator.share({ files: [file], title: finalFilename });
          return;
        }
      }

      // 2) Blob URL + anchor — для Android PWA / desktop
      const blobUrl = window.URL.createObjectURL(pdfBlob);
      const link = window.document.createElement('a');
      link.href = blobUrl;
      link.download = finalFilename;
      link.target = '_self'; // '_self' надійніше ніж '_blank' в iOS standalone
      link.style.display = 'none';
      window.document.body.appendChild(link);
      link.click();
      window.document.body.removeChild(link);
      // Відкликаємо blob URL з затримкою — iOS потребує часу на читання
      setTimeout(() => window.URL.revokeObjectURL(blobUrl), 200);
    } catch (error) {
      console.error('Error downloading file in PWA', error);
      // 3) Останній fallback: відкрити у поточному вікні (iOS може показати Share sheet)
      window.location.href = url;
    } finally {
      setIsDownloading(false);
    }
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDeleting && onDelete) {
      onDelete(document);
    }
  };

  return (
    <a
      href={onClick ? undefined : (document.url || '#')}
      target={onClick ? undefined : "_blank"}
      rel={onClick ? undefined : "noopener noreferrer"}
      className={`cab-card cab-doc-item ${isDeleting ? 'cab-doc-deleting' : ''} ${className}`}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          onClick();
          return;
        } 
        if (!document.url) {
          e.preventDefault();
          return;
        }

        // Перевірка на PWA
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches || ('standalone' in navigator && (navigator as any).standalone === true);
        
        if (isStandalone) {
          e.preventDefault();
          if (!isDownloading) {
            handleDownloadPWA(document.url, document.title || 'document');
          }
        }
      }}
    >
      {/* Іконка документа */}
      <div className={`cab-doc-ic ${isMedyc ? 'cab-doc-ic--medyc' : ''}`}>
        {getMimeIcon(document.mimeType, document.url, isPrescription, document.title)}
      </div>

      {/* Контент */}
      <div className="cab-doc-content">
        <div className="cab-doc-title-row">
          <h4 className="cab-doc-name">{document.title || t('doc_default_name')}</h4>
         
          {document.ereceptaCode && (
            <span className="cab-doc-badge" style={{ background: '#F0EDF6', color: '#111' }}>
              {document.type === 'skierowanie' ? t('doc_code') : t('doc_prescription_code')}: {document.ereceptaCode}
            </span>
          )}
        </div>
        <span className="cab-doc-date">{formatDate(document.date)}</span>
      </div>

      {/* Права частина: delete або download */}
      <div className="cab-doc-actions">
        {document.canDelete && onDelete ? (
          <button
            className="cab-doc-del-btn"
            onClick={handleDeleteClick}
            disabled={isDeleting}
            title={t('doc_delete_btn')}
            aria-label={t('doc_delete_btn')}
          >
            {isDeleting ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="cab-doc-spin">
                <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-.08-6.5"/>
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6"/><path d="M14 11v6"/>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            )}
          </button>
        ) : (
          <div className="cab-doc-dl">
            {isDownloading ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="cab-doc-spin">
                <polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-.08-6.5"/>
              </svg>
            ) : isPrescription ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            )}
          </div>
        )}
      </div>

      <style>{`
        .cab-doc-item {
          display: flex;
          align-items: center;
          margin-bottom: 0;
          gap: 16px;
          text-decoration: none;
          color: inherit;
          transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
          background: #fff;
          border-radius: 20px;
          padding: 5px 0px;
          border: none;
          cursor: pointer;
        }
        @media (min-width: 1024px) {
          .cab-doc-item {
            padding: 24px;
            gap: 20px;
          }
        }
        .cab-doc-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(54, 23, 119, 0.06);
        }
        .cab-doc-deleting {
          opacity: 0.5;
          pointer-events: none;
        }
        .cab-doc-ic {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          background: #FBFAFF;
          color: var(--cab-violet);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .cab-doc-ic--medyc {
          background: #FAF8FE;
          color: #1A5FBF;
        }
        .cab-doc-content {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .cab-doc-title-row {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
        }
        .cab-doc-name {
          font-size: 15px;
          font-weight: 600;
          color: var(--cab-violet);
          margin: 0 0 4px;
          white-space: normal;
          word-break: break-word;
        }
        @media (min-width: 1024px) {
          .cab-doc-name {
            font-size: 16px;
          }
        }
        .cab-doc-badge {
          font-size: 11px;
          font-weight: 600;
          color: #1A5FBF;
          background: #EDF4FF;
          border-radius: 100px;
          padding: 2px 8px;
          white-space: nowrap;
          flex-shrink: 0;
        }
        .cab-doc-date {
          font-size: 14px;
          color: var(--cab-violet);
          font-weight: 400;
        }
        .cab-doc-actions {
          flex-shrink: 0;
        }
        .cab-doc-del-btn {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: var(--cab-violet);
          transition: background 0.2s, color 0.2s;
        }
        .cab-doc-del-btn:hover:not(:disabled) {
          background: #FFF0F0;
          color: #E53E3E;
        }
        .cab-doc-del-btn:disabled {
          cursor: default;
        }
        .cab-doc-dl {
          width: 44px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--cab-violet);
          transition: color 0.2s;
        }
        .cab-doc-item:hover .cab-doc-dl {
          color: var(--cab-violet);
        }
        @keyframes cab-spin {
          to { transform: rotate(360deg); }
        }
        .cab-doc-spin {
          animation: cab-spin 1s linear infinite;
        }
      `}</style>
    </a>
  );
};
